
import { apiFunction } from "../../apiCall/function";
import * as API from "../../apiCall/urls/auth";

// Aadhaar and date of birth go in the request body: URLs are written to server and proxy access logs
// camera: { photo } or { photo_error } from the login camera, as with handleLogin
export const userCheck = (username, camera = {}) => {
    return apiFunction(API.USER_CHECK, "post", { aadhar: username, ...camera }, null, null);
};

// camera: { photo } (JPEG data URL) or { photo_error }, from the login camera
export const handleLogin = (username, password, camera = {}) => {
    return apiFunction(API.LOGIN, "post", { aadhar: username, dob: password, ...camera }, null, null);
};

export const checkFirstLogin = (username, password) => {
    return apiFunction(API.FIRST_LOGIN   + username + "&password=" + password, "get", null, null, null);
};

export const checkValidSystem = (macId) => {
    return apiFunction(API.CHECK_VALID_SYSTEM, "post", {system_id:macId}, null, null);
};

export const checkSession = () => {
    return apiFunction(API.SESSION, "get", null, true, null);
};
